// Reducer to track which tasks have been manually toggled
const initialState = {};

const taskToggleStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TASK_TOGGLE_STATE':
            return {
                ...state,
                [action.payload.taskId]: action.payload.showChildren
            };
        case 'CLEAR_ALL_TASK_TOGGLE_STATES':
            return {};
        default:
            return state;
    }
};

export default taskToggleStateReducer;
